import axios from 'axios';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// elements
import NavBar from './NavBar';
// mui
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Unsubscribe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation('global');

  const params = new URLSearchParams(location.search);
  const userId = params.get('userId');
  const alertId = params.get('alertId');
  const catSlug = params.get('catSlug');

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleUnsubscribe = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/alerts/unsubscribe',
        { userId, alertId, catSlug },
        {
          headers: {
            key: ApiKey,
            contentType: 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        setResult('success');
      } else {
        setResult('error');
      }

      setLoading(false);
    } catch (error) {
      setResult('error');
      setLoading(false);

      console.error('Cannot unsubscribe', error);
    }
  };

  useEffect(() => {
    handleUnsubscribe();
  }, []); // eslint-disable-line
  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container' />
          ) : (
            <div className='mt-5 mb-5'>
              <div className={`jobApplyResultBox ${result === 'success' ? 'success' : 'error'}`}>
                {
                  result === 'success' && (
                    <h2>
                      <CheckCircleIcon sx={{ mr: '8px', width: '40px', height: '40px', color: '#294A9C' }} />
                      {t('jobDescription.unsubscribeSuccess')}
                    </h2>
                  )
                }
                {
                  result === 'error' && (
                    <h2>
                      <ErrorIcon sx={{ mr: '8px', width: '40px', height: '40px', color: '#294A9C' }} />
                      {t('jobDescription.unsubscribeError')}
                    </h2>
                  )
                }
              </div>
              <div className='d-flex justify-content-evenly'>
                <button
                  type='button'
                  onClick={() => navigate('/')}
                  className='mt-0 mb-5 btn button1'
                >
                  {t('jobDescription.backToHome')}
                </button>
              </div>
            </div>
          )
      }
    </>
  );
};

export default Unsubscribe;
